export default "__VITE_ASSET__bsmnLrtH__"